// searchReducer.js
import {
    CONTENT_SEARCH_REQUEST,
    CONTENT_SEARCH_SUCCESS,
    CONTENT_SEARCH_FAILURE
} from '../../../Constants/actionTypes';

const initialState = {
    loading: false,
    results: [],
    error: null,
};

const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONTENT_SEARCH_REQUEST:
            return {
                ...state,
                loading: true,
                results: [],
                error: null,
            };
        case CONTENT_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                results: action.payload,
            };
        case CONTENT_SEARCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default searchReducer;
